var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 288,
    viewBox: "0 0 279 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.8242 142.348C93.8242 136.554 94.8605 130.808 96.933 125.061C99.0055 119.315 102.067 114.157 106.094 109.612C110.122 105.043 115.02 101.369 120.814 98.5661C126.608 95.7635 133.155 94.374 140.479 94.374C149.24 94.374 156.753 96.3288 162.994 100.215C169.235 104.101 173.922 109.164 177.101 115.405L165.161 123.413C163.795 120.516 162.17 118.09 160.286 116.088C158.378 114.11 156.306 112.508 154.045 111.331C151.784 110.153 149.429 109.329 147.003 108.811C144.554 108.316 142.199 108.057 139.961 108.057C134.898 108.057 130.47 109.07 126.678 111.119C122.886 113.144 119.684 115.853 117.116 119.197C114.549 122.541 112.595 126.286 111.276 130.455C109.957 134.623 109.321 138.768 109.321 142.937C109.321 147.647 110.098 152.122 111.629 156.361C113.16 160.6 115.303 164.368 118.082 167.618C120.838 170.869 124.111 173.483 127.903 175.414C131.695 177.369 135.863 178.334 140.385 178.334C142.74 178.334 145.142 178.052 147.639 177.463C150.135 176.874 152.514 175.932 154.822 174.613C157.13 173.294 159.25 171.646 161.204 169.667C163.159 167.689 164.761 165.287 166.009 162.484L178.632 169.667C177.101 173.294 174.935 176.474 172.132 179.229C169.33 181.985 166.174 184.316 162.641 186.224C159.108 188.132 155.387 189.568 151.454 190.557C147.521 191.547 143.659 192.041 139.867 192.041C133.084 192.041 126.89 190.604 121.285 187.708C115.68 184.811 110.852 181.043 106.777 176.38C102.703 171.716 99.5472 166.441 97.2863 160.506C95.0253 154.595 93.8949 148.542 93.8949 142.395L93.8242 142.348Z",
    fill: "#3A5F89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.202 168.254C139.964 168.254 137.751 167.948 135.607 167.359L137.609 160.082C139.093 160.482 140.647 160.694 142.202 160.694C151.716 160.694 159.465 152.946 159.465 143.431C159.465 141.712 159.206 140.04 158.735 138.415L165.941 136.225C166.648 138.556 167.001 140.982 167.001 143.431C167.001 157.115 155.885 168.231 142.202 168.231V168.254Z",
    fill: "#3A5F89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.989 148.872C117.589 147.105 117.4 145.268 117.4 143.455C117.4 129.772 128.517 118.655 142.2 118.655C144.155 118.655 146.086 118.891 147.946 119.338L146.204 126.663C144.908 126.357 143.542 126.192 142.2 126.192C132.685 126.192 124.937 133.94 124.937 143.455C124.937 144.727 125.078 145.998 125.361 147.223L118.013 148.872H117.989Z",
    fill: "#3A5F89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M189.095 110.86C180.711 100.074 172.727 94.3506 159.279 89.0045L163.966 70.9171C181.606 75.486 194.371 84.9301 204.804 99.9322L189.095 110.86Z",
    fill: "#3A5F89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.397 145.88L199.273 145.292C199.273 144.679 199.297 144.067 199.297 143.455C199.297 132.809 196.353 122.423 190.795 113.427L207.069 103.347C214.511 115.381 218.444 129.23 218.444 143.431C218.444 144.232 218.444 145.056 218.397 145.857V145.88Z",
    fill: "url(#paint0_linear_476_3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.508 211.071L168.629 194.114C177.437 189.498 184.926 182.621 190.32 174.236L206.429 184.552C199.269 195.739 189.26 204.9 177.508 211.071Z",
    fill: "#3A5F89"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.135 219.761C134.952 219.761 127.84 218.772 120.986 216.793L126.285 198.4C131.42 199.884 136.742 200.614 142.135 200.614C151.344 200.614 160.105 198.494 168.23 194.326L176.991 211.353C166.299 216.841 154.241 219.761 142.159 219.761H142.135Z",
    fill: "url(#paint1_linear_476_3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.413 216.605C101.996 211.141 86.4285 199.012 76.5605 182.456L92.9993 172.658C100.394 185.07 112.076 194.161 125.853 198.259L120.413 216.605Z",
    fill: "#3A5F89"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0219 181.584C69.3569 170.044 65.8242 156.855 65.8242 143.455C65.8242 142.89 65.8242 142.324 65.8242 141.759L84.9714 142.159C84.9714 142.583 84.9714 143.007 84.9714 143.455C84.9714 153.488 87.6091 163.356 92.602 171.999L76.0219 181.584Z",
    fill: "url(#paint2_linear_476_3)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3601 113.639L77.0391 103.63C84.2457 91.854 94.5141 82.2451 106.737 75.8391L115.64 92.796C106.478 97.6005 98.7769 104.807 93.3836 113.639H93.3601Z",
    fill: "#3A5F89"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M117.645 91.8067L109.426 74.5201C119.694 69.645 130.693 67.1721 142.138 67.1721C148.427 67.1721 154.691 67.9493 160.768 69.4566L156.104 88.015C151.559 86.8845 146.872 86.2957 142.138 86.2957C133.566 86.2957 125.323 88.1563 117.645 91.8067Z",
    fill: "url(#paint3_linear_476_3)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M194.387 94.3504C187.793 87.2851 180.021 81.7034 171.26 77.7468L178.655 61.3316C189.606 66.2773 199.333 73.2485 207.552 82.0802L194.387 94.3504Z",
    fill: "#3A5F89"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.279 135.471C211.607 120.351 205.319 106.385 195.051 95.0805L208.381 82.9751C221.216 97.1059 229.106 114.581 231.178 133.493L213.279 135.471Z",
    fill: "url(#paint4_linear_476_3)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M183.744 223.082L175.336 207.185C192.623 198.023 205.623 182.032 210.969 163.285L228.279 168.231C221.591 191.664 205.364 211.659 183.767 223.082H183.744Z",
    fill: "url(#paint5_linear_476_3)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.687 233.468C130.453 233.468 119.501 231.419 109.139 227.392L115.639 210.623C123.929 213.85 132.69 215.475 141.687 215.475C153.368 215.475 164.979 212.625 175.224 207.208L183.608 223.129C170.772 229.888 156.265 233.468 141.663 233.468H141.687Z",
    fill: "url(#paint6_linear_476_3)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.049 226.991C94.4368 221.504 82.2137 212.649 72.7461 201.344L86.5236 189.757C94.1071 198.8 103.881 205.889 114.785 210.27L108.049 226.968V226.991Z",
    fill: "url(#paint7_linear_476_3)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4805 199.813C60.4349 186.083 53.7228 169.55 52.0742 152.027L69.9967 150.332C71.3156 164.345 76.6853 177.533 85.517 188.532L71.4805 199.813Z",
    fill: "url(#paint8_linear_476_3)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.155 121.223L56.0332 115.664C63.4283 92.8904 79.9613 73.649 101.44 62.9096L109.495 78.9951C92.3021 87.5913 79.0663 102.994 73.155 121.199V121.223Z",
    fill: "url(#paint9_linear_476_3)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.199 77.7232C161.896 73.5546 151.981 71.435 141.689 71.435C134.553 71.435 127.511 72.4712 120.752 74.5202L115.523 57.3042C123.978 54.7371 132.787 53.4418 141.689 53.4418C154.524 53.4418 166.936 56.1031 178.57 61.3315L171.199 77.7467V77.7232Z",
    fill: "url(#paint10_linear_476_3)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.98 62.0145C167.921 56.2915 154.968 53.3947 141.497 53.3947C133.089 53.3947 124.776 54.5487 116.768 56.8332L110.598 35.1896C120.607 32.3399 130.993 30.9033 141.473 30.9033C158.289 30.9033 174.492 34.5302 189.589 41.6662L179.956 62.0145H179.98Z",
    fill: "url(#paint11_linear_476_3)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M207.159 81.7976C199.458 73.6018 190.437 66.9839 180.334 62.1559L190.061 41.8547C202.684 47.9073 213.965 56.1503 223.574 66.3951L207.182 81.7976H207.159Z",
    fill: "url(#paint12_linear_476_3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M230.939 133.022C228.772 114.228 220.859 96.8705 208.07 82.834L224.697 67.667C240.689 85.2126 250.58 106.927 253.289 130.455L230.939 133.022Z",
    fill: "url(#paint13_linear_476_3)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M209.417 233.209L195.828 215.263C218.532 198.07 231.555 171.881 231.555 143.431C231.555 140.087 231.367 136.719 231.014 133.422L253.387 130.949C253.835 135.071 254.07 139.263 254.07 143.431C254.07 161.354 249.972 178.476 241.918 194.349C234.24 209.469 223.006 222.917 209.441 233.185L209.417 233.209Z",
    fill: "url(#paint14_linear_476_3)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M141.499 256.006C100.967 256.006 63.3796 234.057 43.4316 198.73L63.0263 187.661C78.994 215.922 109.069 233.491 141.499 233.491C157.914 233.491 173.953 229.04 187.919 220.609L199.529 239.874C182.054 250.401 161.989 255.983 141.476 255.983L141.499 256.006Z",
    fill: "url(#paint15_linear_476_3)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9968 187.731C31.9912 173.718 28.9531 158.81 28.9531 143.455C28.9531 131.491 30.8372 119.692 34.5112 108.411L55.8958 115.405C52.9519 124.425 51.4446 133.87 51.4446 143.455C51.4446 155.749 53.8704 167.666 58.6748 178.876L37.9968 187.731Z",
    fill: "url(#paint16_linear_476_3)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1011 114.769L34.7637 107.61C46.4215 72.8717 74.3533 45.9055 109.492 35.4958L115.874 57.0688C87.7776 65.3824 65.4274 86.9554 56.1011 114.769Z",
    fill: "url(#paint17_linear_476_3)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M232.922 253.934L215.471 232.573C232.993 218.254 245.546 199.271 251.74 177.651L278.235 185.258C270.486 212.295 254.801 236.035 232.899 253.934H232.922Z",
    fill: "url(#paint18_linear_476_3)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M140.864 287.07C120.798 287.07 101.439 282.855 83.3516 274.541L94.8681 249.482C109.329 256.124 124.802 259.492 140.864 259.492C162.248 259.492 182.973 253.368 200.825 241.805L215.827 264.932C193.501 279.416 167.571 287.07 140.864 287.07Z",
    fill: "url(#paint19_linear_476_3)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9038 272.893C65.0302 265.286 50.923 254.829 38.959 241.829L59.2366 223.152C68.822 233.562 80.1266 241.923 92.8207 248.023L80.9038 272.893Z",
    fill: "url(#paint20_linear_476_3)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9498 255.135C75.4314 248.658 63.4202 239.756 53.2461 228.71L70.5092 212.813C78.6579 221.669 88.2904 228.781 99.1004 233.986L88.9498 255.135Z",
    fill: "url(#paint21_linear_476_3)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6932 197.67C4.97025 184.222 1.43756 169.973 0.212891 155.324L27.6972 152.993C28.6864 164.721 31.5125 176.12 36.0815 186.86L10.7168 197.646L10.6932 197.67Z",
    fill: "url(#paint22_linear_476_3)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M249.625 130.172C246.634 108.646 237.402 88.6039 222.895 72.2358L243.525 53.9365C261.66 74.379 273.2 99.4375 276.945 126.38L249.625 130.148V130.172Z",
    fill: "url(#paint23_linear_476_3)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7716 106.22L3.43945 96.2345C9.79829 78.2178 19.4308 61.7319 32.0542 47.295C44.6777 32.8581 59.6799 21.1296 76.6603 12.4156L90.3671 39.1463C62.8593 53.2535 42.04 77.0874 31.7481 106.22H31.7716Z",
    fill: "url(#paint24_linear_476_3)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M187.489 40.5124C172.628 34.2006 156.825 30.9976 140.528 30.9976C131.084 30.9976 121.687 32.1046 112.596 34.2477L105.648 5.04416C117.024 2.33576 128.752 0.969788 140.528 0.969788C160.876 0.969788 180.636 4.9735 199.218 12.8867L187.466 40.5359L187.489 40.5124Z",
    fill: "url(#paint25_linear_476_3)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M226.852 67.5726C215.83 56.1974 202.9 47.2243 188.439 40.9361L200.427 13.4047C218.514 21.2708 234.647 32.4812 248.425 46.6827L226.852 67.5726Z",
    fill: "url(#paint26_linear_476_3)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M142.111 153.511C148.16 153.511 153.063 148.608 153.063 142.56C153.063 136.511 148.16 131.608 142.111 131.608C136.063 131.608 131.16 136.511 131.16 142.56C131.16 148.608 136.063 153.511 142.111 153.511Z",
    fill: "#3A5F89"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_476_3",
    x1: 190.795,
    y1: 124.614,
    x2: 218.444,
    y2: 124.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_476_3",
    x1: 120.986,
    y1: 207.043,
    x2: 176.991,
    y2: 207.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_476_3",
    x1: 65.8478,
    y1: 161.66,
    x2: 92.602,
    y2: 161.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_476_3",
    x1: 109.426,
    y1: 79.4659,
    x2: 160.768,
    y2: 79.4659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_476_3",
    x1: 237.16,
    y1: 97.3414,
    x2: 196.158,
    y2: 123.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_476_3",
    x1: 201.454,
    y1: 163.568,
    x2: 202.867,
    y2: 266.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_476_3",
    x1: 186.787,
    y1: 204.17,
    x2: 121.739,
    y2: 227.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_476_3",
    x1: 72.7461,
    y1: 208.362,
    x2: 114.785,
    y2: 208.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_476_3",
    x1: 52.0742,
    y1: 175.061,
    x2: 85.517,
    y2: 175.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_476_3",
    x1: 56.0332,
    y1: 92.0661,
    x2: 109.495,
    y2: 92.0661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_476_3",
    x1: 115.523,
    y1: 65.5707,
    x2: 178.57,
    y2: 65.5707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_476_3",
    x1: 152.566,
    y1: 15.8069,
    x2: 145.03,
    y2: 85.0947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_476_3",
    x1: 180.31,
    y1: 61.8497,
    x2: 223.551,
    y2: 61.8497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_476_3",
    x1: 218.103,
    y1: 70.0692,
    x2: 245.917,
    y2: 138.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_476_3",
    x1: 223.524,
    y1: 169.903,
    x2: 248.677,
    y2: 245.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_476_3",
    x1: 178.804,
    y1: 246.539,
    x2: 62.3904,
    y2: 206.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_476_3",
    x1: 38.3501,
    y1: 97.3415,
    x2: 48.2652,
    y2: 183.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_476_3",
    x1: 34.7637,
    y1: 75.1562,
    x2: 115.874,
    y2: 75.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_476_3",
    x1: 215.471,
    y1: 215.804,
    x2: 278.235,
    y2: 215.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_476_3",
    x1: 83.3516,
    y1: 264.414,
    x2: 215.851,
    y2: 264.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_476_3",
    x1: 39.1711,
    y1: 249.063,
    x2: 92.7926,
    y2: 247.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_476_3",
    x1: 82.4497,
    y1: 237.26,
    x2: 39.0682,
    y2: 200.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_476_3",
    x1: 0.212891,
    y1: 175.343,
    x2: 36.0815,
    y2: 175.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_476_3",
    x1: 222.343,
    y1: 91.3296,
    x2: 278.015,
    y2: 93.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_476_3",
    x1: 3.463,
    y1: 59.3297,
    x2: 90.3907,
    y2: 59.3297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_476_3",
    x1: 105.648,
    y1: 20.7528,
    x2: 199.218,
    y2: 20.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_476_3",
    x1: 188.439,
    y1: 40.4887,
    x2: 248.425,
    y2: 40.4887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#448299"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/LogoMobile.17094fcd958542b35a50f172a7d8418a.svg";
export { ForwardRef as ReactComponent };